<form>
  <span class="input-group-btn" style="display: none">
    <button class="btn btn-warning btn-sm" (click)="funcion1()" id="btn-chat1">
      Send1
    </button>
  </span>

  <div class="input-area">
    <div class="input-group flex-column">
      <div
        #suggestionsBox
        class="suggestions-box"
        *ngIf="suggestionsBoxVisible"
      >
        <div
          class="result-item-container"
          [ngClass]="{ selected: username === selected }"
          (mouseover)="onResultItemHover(username)"
          (click)="onResultItemClick(username)"
          *ngFor="let username of filteredUsernames"
        >
          <div class="result-item">
            {{ username | Usernametag }}
          </div>
        </div>
      </div>

      <div class="d-flex align-items-end">
        <textarea
          class="form-control"
          #messageInput
          (keyup)="onKeyUp($event)"
          (keydown)="onKeyDown($event)"
          (focus)="onFocus()"
          placeholder="Leave your comment here"
          [disabled]="deshabilitado"
        ></textarea>
        <!-- <input
          #messageInput
          class="form-control input-sm"
          type="text"
          (keyup)="onKeyUp($event)"
          (keydown)="onKeyDown($event)"
          (focus)="onFocus()"
          (keyup.enter)="sendChat()"
          placeholder="Type message here"
          [disabled]="deshabilitado"
        /> -->

        <!--<button
          class="btn btn-md w-25"
          [ngClass]="[
          isEdit ? 'btn-success' : 'btn-warning']"
          (click)="sendChat()"
          id="btn-chat"
          [disabled]="deshabilitado || loading"
        >
         <span *ngIf="!isEdit">Send</span>
         <span *ngIf="isEdit">Save</span>
        </button>-->
        <!--<i class="material-icons icon-send">send</i>-->
        <div class="circulo" (click)="sendChat()">
          <i class="material-icons" style="font-size: 10px;">send</i>
        </div>
      </div>
    </div>
  </div>
</form>
